import { render, staticRenderFns } from "./VManualInvoiceForm.vue?vue&type=template&id=55b74923&"
import script from "./VManualInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./VManualInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports